<template>
    <div class="form-field form-field__input" :class="[rootClasses]">
        <label class="form-field--title-label"
                v-if="label" :for="id"
                v-text="label">
        </label>
        <div class="form-field--input-container" :data-action-count="actionCount">
            <span class="form-field--floating-label"
                    v-if="hasFloatingLabel"
                    aria-hidden="true"
                    v-text="label">
            </span>
            <input class="form-field--input"
                    ref="input"
                    v-bind="inputBindings"
                    @input="updateValue($event.target.value)"
                    @focus="onFocus"
                    @blur="onBlur">
            <div class="form-field--actions">
                <button v-if="type === 'date'" class="form-field--action form-field--action__date">
                    <cmp-icon symbol="calendar" size="medium"></cmp-icon>
                </button>
            </div>
        </div>
        <cmp-form-field-messages-partial :messages="messages"></cmp-form-field-messages-partial>
    </div>
</template>

<script>
    import formFieldAbstractMixin from 'vue/mixins/form/form-field-abstract';


    export default {
        inheritAttrs: false,
        mixins: [
            formFieldAbstractMixin,
        ],
        props: {
            type: {
                type: String,
                default: 'text',
            },
            pattern: {
                type: String,
            },
        },
        computed: {
            specificRootClasses() {
                return {
                    'form-field__has-focus': this.hasFocus,
                    'form-field__is-hidden': this.state.hidden,
                };
            },
            specificInputBindings() {
                const { type, placeholder, pattern } = this;

                return {
                    type,
                    placeholder,
                    pattern,
                };
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?10adb4a1